import React, { useState } from 'react'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons/faExternalLink'
import { apiClient } from 'pobble-components/dist/api'
import { toast } from 'pobble-components/dist/toast'
import posthog from 'posthog-js'
import { Modal, ModalContent, ModalFooter } from 'pobble-components/dist/modal'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import Checkmark from '../print-modal/animated-checkmark'
import injectSheet from 'react-jss'

export function useWritingPack({ presentation }) {
  const [writingPackState, setWritingPackState] = useState({
    pending: false,
    url: null,
    modalOpen: false
  })

  const { hasAccessToTL } = useSubscriptionDetails()

  function handleWritingPackClick() {
    apiClient.post('/v3/me/activated_with_product', {
      type: 'feature'
    })
    posthog.capture('activate', { type: 'feature' })
    posthog.capture('click on writing pack', {
      hasAccess: hasAccessToTL
    })

    const today = new Date().toDateString()
    const storedData = JSON.parse(
      localStorage.getItem('writingPacksUsed') || '{}'
    )

    if (storedData.date !== today) {
      storedData.date = today
      storedData.packs = []
    }

    if (!storedData.packs) {
      storedData.packs = []
    }

    if (
      !storedData.packs.includes(presentation.id) &&
      storedData.packs.length >= 5
    ) {
      toast.error(
        "You've reached a daily limit of 5 writing packs. Please try again tomorrow!"
      )
      return
    }

    setWritingPackState({
      pending: true,
      url: null,
      modalOpen: true
    })
    apiClient
      .get(`/v3/presentations/${presentation.id}/answer_sheet_pdf`)
      .then(res => {
        setWritingPackState({
          pending: false,
          url: res.data.url,
          modalOpen: true
        })

        posthog.capture('generated writing pack')

        if (!storedData.packs.includes(presentation.id)) {
          storedData.packs.push(presentation.id)
          localStorage.setItem('writingPacksUsed', JSON.stringify(storedData))
        }
      })
      .catch(e => {
        setWritingPackState({
          pending: false,
          url: null,
          modalOpen: false
        })
      })
  }

  return {
    handleWritingPackClick,
    closeWritingPackModal: () =>
      setWritingPackState({
        ...writingPackState,
        modalOpen: false
      }),
    writingPackState
  }
}

export const WritingPackModal = injectSheet({
  content: {
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
})(function WritingPackModal({
  classes,
  pending,
  modalOpen,
  url,
  requestClose,
  ...props
}) {
  return (
    <Modal isOpen={modalOpen} {...props}>
      <ModalContent className={classes.content}>
        <Checkmark ready={!!url} />
        <span>
          {!url && 'Preparing writing pack...'}
          {!!url && 'Writing pack is ready'}
        </span>
      </ModalContent>
      <ModalFooter alignRight childrenGap>
        <Button simple tall action={requestClose}>
          Close
        </Button>
        <Button
          minw
          pending={pending}
          disabled={pending}
          icon={<FontAwesomeIcon icon={faExternalLink} />}
          tall
          onClick={() => {
            requestClose()
            window.open(url, '_blank')
          }}>
          Open
        </Button>
      </ModalFooter>
    </Modal>
  )
})
